import { render, staticRenderFns } from "./CommoditySearch.vue?vue&type=template&id=1006e1ca&"
import script from "./CommoditySearch.vue?vue&type=script&lang=js&"
export * from "./CommoditySearch.vue?vue&type=script&lang=js&"
import style0 from "./CommoditySearch.vue?vue&type=style&index=0&id=1006e1ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports